import App from "../../app";
import { FilterValue } from "../../lib/filter";
import { ListItem } from "../../model/datasource/list";
import { ContentItem } from "../../model/datasource/item";
import { ListFrontend, SettingsFrontend } from "../frontend";
import { ListView, SettingsView } from "../view";
import { AttemptId, ProductId, ItemId, QuizId } from "../../model/datasource";
import { AnswerType } from "../../lib/userdata";

export class CommonListView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> extends ListView<P, A, Z, I> {
	constructor(frontend?: ListFrontend<I>) {
		super(frontend);
	}

	init(app: App<P, A, Z, I>): void {
		const bindTarget = app.view.getBindTarget();
		[
			this.frontend.getBindJump(),
			this.frontend.getBindToggleFilter(),
			this.frontend.getBindSetFilter(),
			this.frontend.getBindFilterLinks(),
		].forEach(bind => bind.bind(bindTarget));
		this.frontend.bindCollapseIcons();
		this.frontend.bindSectionHighlight();
	}

	displaySelectedAnswer(item: I, answer: AnswerType | null, status?: "loading" | "error" | undefined): void {
		this.frontend.displaySelectedAnswer(item, answer, status);
	}

	displayCurrent(index: number): void {
		this.frontend.displayCurrent(index);
	}

	displayFilters(filters: FilterValue[], bindTarget: EventTarget): void {
		this.frontend.displayFilters(filters, bindTarget);
	}

	displayFiltered(filtered: number[]): void {
		this.frontend.displayFiltered(filtered);
	}

	displayFlagged(item: I, flagged: boolean, status?: undefined | "loading" | "error"): void {
		this.frontend.displayFlagged(item, flagged, status);
	}

	displaySorted(order: number[]): void {
		this.frontend.displaySorted(order);
	}
}

export class CommonSettingsView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> extends SettingsView<P, A, Z, I> {
	constructor(frontend?: SettingsFrontend<I>) {
		super(frontend);
	}

	init(app: App<P, A, Z, I>): void {
		const bindTarget = app.view.getBindTarget();
		[
			this.frontend.getBindToggleTimer(),
			this.frontend.getBindKeyboardShortcuts(),
			this.frontend.getBindChangeFontSize(),
			this.frontend.getBindResetFontSize(),
			this.frontend.getBindToggleReport(),
			this.frontend.getBindReportError(),
			this.frontend.getBindToggleAutoAdvance(),
			this.frontend.getBindChangeAdvanceInterval(),
			this.frontend.getBindResetTimer(),
			this.frontend.getBindEnterEmail(),
			this.frontend.getBindOverrideInput(),
		].forEach(bind => bind.bind(bindTarget));
	}

	displayFontSize(size: number): void {
		this.frontend.displayFontSize(size);
	}

	displayKeyboardShortcuts(enabled: boolean): void {
		this.frontend.displayKeyboardShortcuts(enabled);
	}

	displayTimer(show: boolean): void {
		this.frontend.displayTimer(show);
	}

	toggleShortcutModal(jQuery: JQueryStatic): void {
		this.frontend.toggleShortcutModal(jQuery);
	}

	displayErrorLoading(show: boolean): void {
		this.frontend.displayErrorLoading(show);
	}

	displayErrorModal(jQuery: JQueryStatic, url: string, item: ContentItem<I> | ListItem<I>, filters: FilterValue[], screenshot: string, errors: (Error | any)[], localStorage: Record<string, any>): void {
		this.frontend.displayErrorModal(jQuery, url, item, filters, screenshot, errors, localStorage);
	}

	hideErrorModal(jQuery: JQueryStatic, success: boolean, reason: string): void {
		this.frontend.hideErrorModal(jQuery);
		this.frontend.displayErrorResultModal(jQuery, success, reason);
	}

	displayInputSuggestion(element: HTMLElement, suggestion: string | undefined) {
		this.frontend.displayInputSuggestion(element, suggestion);
	}

	updateInputs(root: HTMLElement, selector: string, value: string): HTMLInputElement[] {
		return this.frontend.updateInputs(root, selector, value);
	}

	displayReportErrorMessage(message: string): void {
		this.frontend.displayReportErrorMessage(message);
	}

	displayAdvance(enable: boolean): void {
		this.frontend.displayAdvance(enable);
	}

	displayAdvanceInterval(interval: number): void {
		this.frontend.displayAdvanceInterval(interval);
	}

	displayTimed(enable: boolean): void {
		this.frontend.displayTimed(enable);
	}
}